import { render, staticRenderFns } from "./TilesSection.vue?vue&type=template&id=bb97572e&scoped=true"
import script from "./TilesSection.vue?vue&type=script&lang=js"
export * from "./TilesSection.vue?vue&type=script&lang=js"
import style0 from "./TilesSection.vue?vue&type=style&index=0&id=bb97572e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97572e",
  null
  
)

export default component.exports